'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronleft from '@common/__generated__/icon/SvgChevronleft';
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { chunk } from 'es-toolkit';
import { PHOTO_REVIEW_BENEFIT_AMOUNT } from '@/app/donation/_hooks/usePhotoReviewEvent/constants';
import { usePhotoReviewEvent } from '@/app/donation/_hooks/usePhotoReviewEvent/usePhotoReviewEvent';
import { BREAKPOINTS, WEBVIEW_TYPE_ENTRY } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useSelectedSnapIndex } from '@/hooks/useSelectedSnapIndex';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { WeeklyBestPhotoReviewListItem } from './WeeklyBestPhotoReviewListItem';
import type { WeeklyBestPhotoReviewItem } from './WeeklyBestPhotoReviewSectionServer';
interface WeeklyBestPhotoReviewSectionProps {
  items: WeeklyBestPhotoReviewItem[];
  className?: string;
}
export const WeeklyBestPhotoReviewSection = t0 => {
  const $ = _c(64);
  const {
    items,
    className
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: false,
      align: "start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const currentSlide = useSelectedSnapIndex(emblaApi);
  const {
    isEventProcess
  } = usePhotoReviewEvent();
  const {
    entry
  } = useWebviewTypeEntry();
  const CHUNK_SIZE = isDesktop ? 6 : 2;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== CHUNK_SIZE || $[2] !== className || $[3] !== currentSlide || $[4] !== emblaApi || $[5] !== emblaRef || $[6] !== entry || $[7] !== isDesktop || $[8] !== isEventProcess || $[9] !== items) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const chunkedList = chunk(items, CHUNK_SIZE);
      const isShowBenefit = isEventProcess && entry === WEBVIEW_TYPE_ENTRY.WELLO;
      const isNotRender = items.length < 1;
      if (isNotRender) {
        t9 = null;
        break bb0;
      }
      if ($[18] !== className) {
        t8 = cn("flex w-full justify-center bg-Y-25 pt-60", "mobile-tablet:pt-32", className);
        $[18] = className;
        $[19] = t8;
      } else {
        t8 = $[19];
      }
      let t10;
      let t11;
      if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = cn("flex flex-col items-center gap-24 px-40 content-container", "mobile-tablet:gap-16 mobile-tablet:px-0");
        t10 = cn("grid w-full grid-cols-[1fr_auto_1fr] items-end", "mobile-tablet:flex mobile-tablet:items-center mobile-tablet:px-20");
        t11 = <div className="mobile-tablet:hidden" />;
        $[20] = t10;
        $[21] = t11;
        $[22] = t6;
      } else {
        t10 = $[20];
        t11 = $[21];
        t6 = $[22];
      }
      let t12;
      if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <h2 className={cn("font-800 text-Gray-900 typo-h4", "mobile-tablet:font-700 mobile-tablet:typo-body1")}>주간 BEST 포토리뷰!</h2>;
        $[23] = t12;
      } else {
        t12 = $[23];
      }
      let t13;
      if ($[24] !== isShowBenefit) {
        t13 = isShowBenefit && <p className="whitespace-nowrap rounded-xsmall bg-O-400 px-6 pb-2 pt-3 font-600 text-Gray-white typo-caption1">포토후기 {formatAmount()} 지급</p>;
        $[24] = isShowBenefit;
        $[25] = t13;
      } else {
        t13 = $[25];
      }
      let t14;
      if ($[26] !== t13) {
        t14 = <header className="flex items-center gap-8">{t12}{t13}</header>;
        $[26] = t13;
        $[27] = t14;
      } else {
        t14 = $[27];
      }
      let t15;
      if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = cn("flex flex-1 items-center justify-end gap-8", "mobile-tablet:hidden");
        $[28] = t15;
      } else {
        t15 = $[28];
      }
      const t16 = currentSlide + 1;
      let t17;
      if ($[29] !== t16) {
        t17 = <span className="font-700 text-Gray-600">{t16}</span>;
        $[29] = t16;
        $[30] = t17;
      } else {
        t17 = $[30];
      }
      let t18;
      if ($[31] !== emblaApi) {
        t18 = () => emblaApi?.scrollPrev();
        $[31] = emblaApi;
        $[32] = t18;
      } else {
        t18 = $[32];
      }
      let t19;
      if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = <SvgChevronleft className="size-18 text-Gray-500" />;
        $[33] = t19;
      } else {
        t19 = $[33];
      }
      let t20;
      if ($[34] !== t18) {
        t20 = <Button theme="sub-line" className="size-24 rounded-[2px] bg-Gray-white p-0" onClick={t18}>{t19}</Button>;
        $[34] = t18;
        $[35] = t20;
      } else {
        t20 = $[35];
      }
      let t21;
      if ($[36] !== emblaApi) {
        t21 = () => emblaApi?.scrollNext();
        $[36] = emblaApi;
        $[37] = t21;
      } else {
        t21 = $[37];
      }
      let t22;
      if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = <SvgChevronright className="size-18 text-Gray-500" />;
        $[38] = t22;
      } else {
        t22 = $[38];
      }
      let t23;
      if ($[39] !== t21) {
        t23 = <Button theme="sub-line" className="size-24 rounded-[2px] bg-Gray-white p-0" onClick={t21}>{t22}</Button>;
        $[39] = t21;
        $[40] = t23;
      } else {
        t23 = $[40];
      }
      let t24;
      if ($[41] !== t20 || $[42] !== t23) {
        t24 = <div className="flex">{t20}{t23}</div>;
        $[41] = t20;
        $[42] = t23;
        $[43] = t24;
      } else {
        t24 = $[43];
      }
      const t25 = <div className={t15}><p className="font-500 text-Gray-550 typo-body4">{t17}{" "}/ {chunkedList.length}</p>{t24}</div>;
      if ($[44] !== t14 || $[45] !== t25) {
        t7 = <header className={t10}>{t11}{t14}{t25}</header>;
        $[44] = t14;
        $[45] = t25;
        $[46] = t7;
      } else {
        t7 = $[46];
      }
      if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = cn("w-full overflow-hidden pb-60", "mobile-tablet:px-20 mobile-tablet:pb-32");
        $[47] = t4;
      } else {
        t4 = $[47];
      }
      t5 = emblaRef;
      t2 = "flex";
      let t26;
      if ($[48] !== isDesktop) {
        t26 = (chunkItems, chunkIndex) => <div key={chunkIndex} className={cn(isDesktop ? "min-w-0 flex-[0_0_100%]" : "mr-32 min-w-0 flex-[0_0_auto] last:mr-0")}><ul className={cn("flex flex-wrap gap-16", "mobile-tablet:flex-col mobile-tablet:gap-12")}>{chunkItems.map((t27, index) => {
              const {
                reviewId,
                contents,
                productName,
                rating,
                fileUrl
              } = t27;
              return <WeeklyBestPhotoReviewListItem key={`${chunkIndex}-${index}`} reviewId={reviewId} productThumbnailUrl={fileUrl} productName={productName} rating={rating} reviewContent={contents} />;
            })}</ul></div>;
        $[48] = isDesktop;
        $[49] = t26;
      } else {
        t26 = $[49];
      }
      t3 = chunkedList.map(t26);
    }
    $[1] = CHUNK_SIZE;
    $[2] = className;
    $[3] = currentSlide;
    $[4] = emblaApi;
    $[5] = emblaRef;
    $[6] = entry;
    $[7] = isDesktop;
    $[8] = isEventProcess;
    $[9] = items;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[50] !== t2 || $[51] !== t3) {
    t10 = <div className={t2}>{t3}</div>;
    $[50] = t2;
    $[51] = t3;
    $[52] = t10;
  } else {
    t10 = $[52];
  }
  let t11;
  if ($[53] !== t10 || $[54] !== t4 || $[55] !== t5) {
    t11 = <div className={t4} ref={t5}>{t10}</div>;
    $[53] = t10;
    $[54] = t4;
    $[55] = t5;
    $[56] = t11;
  } else {
    t11 = $[56];
  }
  let t12;
  if ($[57] !== t11 || $[58] !== t6 || $[59] !== t7) {
    t12 = <div className={t6}>{t7}{t11}</div>;
    $[57] = t11;
    $[58] = t6;
    $[59] = t7;
    $[60] = t12;
  } else {
    t12 = $[60];
  }
  let t13;
  if ($[61] !== t12 || $[62] !== t8) {
    t13 = <section className={t8}>{t12}</section>;
    $[61] = t12;
    $[62] = t8;
    $[63] = t13;
  } else {
    t13 = $[63];
  }
  return t13;
};
const formatAmount = () => {
  if (PHOTO_REVIEW_BENEFIT_AMOUNT >= 10000) {
    return `${PHOTO_REVIEW_BENEFIT_AMOUNT / 10000}만원`;
  }
  if (PHOTO_REVIEW_BENEFIT_AMOUNT >= 1000) {
    return `${PHOTO_REVIEW_BENEFIT_AMOUNT / 1000}천원`;
  }
  return `${PHOTO_REVIEW_BENEFIT_AMOUNT}원`;
};